// extracted by mini-css-extract-plugin
module.exports = {"fallbackContainer":"login_fallbackContainer__KxK86","spinner":"login_spinner__0Jvkt","spin":"login_spin__7YW_Q"};